import React from "react";

/** Tier labels. The score alone does not say what to do about it. */
const LABELS = {
  critical: "Critical",
  at_risk: "At risk",
  watch: "Watch",
  healthy: "Healthy",
  growing: "Growing",
};

/**
 * A client's health tier and score.
 *
 * The tier word carries the meaning, not the colour, so the badge still reads
 * for anyone who cannot separate the red from the green.
 */
export function RiskBadge({ level, score, signalCount }) {
  const tier = LABELS[level] ? level : "healthy";

  return (
    <span
      className={`ct-risk ct-risk--${tier}`}
      title={
        signalCount
          ? `${signalCount} signal${signalCount === 1 ? "" : "s"} detected — open the row to see them`
          : "No signals detected"
      }
    >
      <span className="ct-risk-label">{LABELS[tier]}</span>
      <span className="ct-risk-score">{score ?? 0}</span>
    </span>
  );
}
